module.exports = __webpack_public_path__ + "img/contract-expire-1.9d235e40.svg";